import { render, staticRenderFns } from "./MitManageGroupsPage.vue?vue&type=template&id=0f55321e&scoped=true"
import script from "./MitManageGroupsPage.vue?vue&type=script&lang=js"
export * from "./MitManageGroupsPage.vue?vue&type=script&lang=js"
import style0 from "./MitManageGroupsPage.vue?vue&type=style&index=0&id=0f55321e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55321e",
  null
  
)

export default component.exports